export const normalizeProfilePlayerCode = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const upper = raw.toUpperCase();
  if (/^\d{4}$/.test(raw)) return `XIMA-${raw}`;
  if (/^XIMA-\d{4}$/.test(upper)) return upper;
  return "";
};

export const resolveProfileTargetFromValue = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const byCode = normalizeProfilePlayerCode(raw);
  if (byCode) return byCode;
  return raw;
};

export const resolveProfileTargetFromUserLike = (rawUser) => {
  if (rawUser && typeof rawUser === "object") {
    const byCode = normalizeProfilePlayerCode(rawUser?.playerCode);
    if (byCode) return byCode;

    const byLogin = resolveProfileTargetFromValue(rawUser?.loginIdentifier || rawUser?.email);
    if (byLogin) return byLogin;

    const byId = resolveProfileTargetFromValue(
      rawUser?.userIdNormalized || rawUser?.userId || rawUser?.id || rawUser?._id || rawUser?.identity
    );
    if (byId) return byId;
    return "";
  }
  return resolveProfileTargetFromValue(rawUser);
};

export const buildCurrentUserProfileIdentitySet = (user) => {
  const identities = new Set();
  const addIdentity = (value) => {
    const normalized = String(value || "")
      .trim()
      .toLowerCase();
    if (!normalized) return;
    identities.add(normalized);
    if (normalized.includes("@")) {
      const localPart = String(normalized.split("@")[0] || "").trim();
      if (localPart) identities.add(localPart);
    }
  };

  addIdentity(user?.email);
  addIdentity(user?.loginIdentifier);
  addIdentity(user?.username);
  addIdentity(user?.userName);
  addIdentity(user?._id);
  addIdentity(user?.id);
  addIdentity(user?.userId);
  const normalizedPlayerCode = normalizeProfilePlayerCode(user?.playerCode);
  if (normalizedPlayerCode) addIdentity(normalizedPlayerCode);
  return identities;
};

export const resolvePlayerProfileRoute = (rawUser, currentUserProfileIdentitySet) => {
  const target = resolveProfileTargetFromUserLike(rawUser);
  if (!target) return "";

  const targetCandidates = new Set();
  const normalizedTarget = String(target || "")
    .trim()
    .toLowerCase();
  if (normalizedTarget) {
    targetCandidates.add(normalizedTarget);
    if (normalizedTarget.includes("@")) {
      const localPart = String(normalizedTarget.split("@")[0] || "").trim();
      if (localPart) targetCandidates.add(localPart);
    }
  }

  const normalizedTargetCode = normalizeProfilePlayerCode(target);
  if (normalizedTargetCode) {
    targetCandidates.add(String(normalizedTargetCode).trim().toLowerCase());
  }

  const isSelf = Array.from(targetCandidates).some((identity) =>
    currentUserProfileIdentitySet.has(identity)
  );
  if (isSelf) {
    return "/game/stats";
  }

  return `/game/player/${encodeURIComponent(target)}`;
};
